import { render, staticRenderFns } from "./add-marketing-staff.vue?vue&type=template&id=29a4a892&scoped=true&"
import script from "./add-marketing-staff.vue?vue&type=script&lang=js&"
export * from "./add-marketing-staff.vue?vue&type=script&lang=js&"
import style0 from "./add-marketing-staff.vue?vue&type=style&index=0&id=29a4a892&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a4a892",
  null
  
)

export default component.exports